import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import { profileQueries } from '~entities/user';
import { clearAllRevisions } from '~shared/api';

import { postLogout } from './api';

export const useLogout = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationFn: postLogout,
    onSuccess: (_, group) => {
      queryClient.setQueryData(profileQueries.all(group), null);
      clearAllRevisions(group);
    },
  });

  return { onLogout: mutate };
};
